import React, { useEffect, useMemo, useState } from 'react';
import './Dropdown.css';
import LoadingOverlay from '../components/LoadingOverlay';
import BASE_URL from '../utils/api';

const ABAS = [
  { chave: 'desenvolvimento', titulo: 'Desenvolvimento' },
  { chave: 'entregasProjeto', titulo: 'Entregas de Projetos' },
  { chave: 'entregasProduto', titulo: 'Entregas de Produtos' },
  { chave: 'montagem', titulo: 'Montagem' },
  { chave: 'aprovacao', titulo: 'Aprovação do Projeto' }
];

const SITUACOES = ['Atrasado', 'Risco de Atraso', 'Dentro do Prazo', 'Concluído com Atraso', 'Concluído Dentro do Prazo', 'Concluído', 'Sem Previsão'];

const corSituacao = (s) => {
  if (s === 'Atrasado' || s === 'Concluído com Atraso') return { bg: '#fdecea', text: '#d93025' };
  if (s === 'Risco de Atraso') return { bg: '#fff8e1', text: '#b26a00' };
  if (s === 'Sem Previsão') return { bg: '#eceff1', text: '#455a64' };
  return { bg: '#e6f4ea', text: '#1e8e3e' };
};

const dataBr = (d) => (d ? d.split('-').reverse().join('/') : '—');
const reais = (v) => (v == null ? '—' : Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
const celula = { padding: '10px 12px', borderBottom: '1px solid #eee', whiteSpace: 'nowrap', fontSize: 14 };
const cabecalho = { ...celula, background: '#fff3e0', color: 'rgb(184, 98, 0)', fontWeight: 700, textAlign: 'left', fontSize: 13 };

export default function PrazosDropdown() {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [aba, setAba] = useState('desenvolvimento');
  const [filtro, setFiltro] = useState('');
  const [situacao, setSituacao] = useState('');

  useEffect(() => {
    const carregar = async () => {
      try {
        const res = await fetch(`${BASE_URL}/Prazos`);
        if (!res.ok) throw new Error(`Erro ${res.status}`);
        setDados(await res.json());
      } catch (err) {
        setErro('Erro ao carregar os prazos: ' + err.message);
      }
    };
    carregar();
  }, []);

  const linhas = useMemo(() => {
    const termo = filtro.toLowerCase().trim();
    return (dados?.[aba] || []).filter(l => {
      if (situacao && l.situacao !== situacao) return false;
      if (!termo) return true;
      return [l.projetoId, l.contratoId, l.vendaId, l.orcamentoId, l.clienteId, l.clienteNome, l.referencia]
        .some(v => String(v ?? '').toLowerCase().includes(termo));
    });
  }, [dados, aba, filtro, situacao]);

  const ehProduto = aba === 'entregasProduto';

  return (
    <div className="container-geral fundo-branco" style={{ padding: 20 }}>
      <h2 style={{ color: 'rgb(235, 133, 0)', textAlign: 'center', marginTop: 0 }}>Prazos</h2>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', marginBottom: 14 }}>
        {ABAS.map(a => (
          <button key={a.chave} type="button" onClick={() => setAba(a.chave)} style={{
            padding: '8px 14px', borderRadius: 6, border: '1px solid rgb(235, 133, 0)', cursor: 'pointer', fontWeight: 600,
            background: aba === a.chave ? 'rgb(235, 133, 0)' : '#fff', color: aba === a.chave ? '#fff' : 'rgb(235, 133, 0)'
          }}>
            {a.titulo} ({dados?.[a.chave]?.length ?? 0})
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center', marginBottom: 14 }}>
        <input placeholder="Filtrar por ID ou cliente..." value={filtro} onChange={e => setFiltro(e.target.value)} style={{ padding: 10, borderRadius: 6, border: '1px solid #ddd', minWidth: 240 }} />
        <select value={situacao} onChange={e => setSituacao(e.target.value)} style={{ padding: 10, borderRadius: 6, border: '1px solid #ddd' }}>
          <option value="">Todas as situações</option>
          {SITUACOES.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      {erro && <div style={{ textAlign: 'center', padding: 16, color: '#b00020', background: '#fdecea', borderRadius: 6 }}>{erro}</div>}

      {dados && (
        <div style={{ overflowX: 'auto', background: '#fff', borderRadius: 8, border: '1px solid #eee' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {!ehProduto && <th style={cabecalho}>ID Projeto</th>}
                {!ehProduto && <th style={cabecalho}>ID Contrato</th>}
                <th style={cabecalho}>ID Venda</th>
                <th style={cabecalho}>ID Orçamento</th>
                <th style={cabecalho}>ID Cliente</th>
                <th style={cabecalho}>Cliente</th>
                <th style={cabecalho}>{ehProduto ? 'Valor Venda' : 'Valor Contrato'}</th>
                <th style={cabecalho}>Item</th>
                <th style={cabecalho}>Previsto</th>
                <th style={cabecalho}>Concluído</th>
                <th style={cabecalho}>Situação</th>
              </tr>
            </thead>
            <tbody>
              {linhas.length === 0 ? (
                <tr><td colSpan={11} style={{ padding: 30, textAlign: 'center', color: '#666' }}>Nenhum prazo encontrado.</td></tr>
              ) : linhas.map((l, i) => {
                const cor = corSituacao(l.situacao);
                return (
                  <tr key={i}>
                    {!ehProduto && <td style={celula}>{l.projetoId ?? '—'}</td>}
                    {!ehProduto && <td style={celula}>{l.contratoId ?? '—'}</td>}
                    <td style={celula}>{l.vendaId ?? '—'}</td>
                    <td style={celula}>{l.orcamentoId ?? '—'}</td>
                    <td style={celula}>{l.clienteId ?? '—'}</td>
                    <td style={celula}>{l.clienteNome || '—'}</td>
                    <td style={celula}>{reais(l.valorContrato)}</td>
                    <td style={celula}>{l.referencia}</td>
                    <td style={celula}>{dataBr(l.previsto)}</td>
                    <td style={celula}>{dataBr(l.concluido)}</td>
                    <td style={celula}><span style={{ padding: '4px 10px', borderRadius: 12, background: cor.bg, color: cor.text, fontWeight: 600 }}>{l.situacao}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      <LoadingOverlay isLoading={!dados && !erro} message="Carregando prazos..." />
    </div>
  );
}
